import React from "react";
import ComingSoon from "../componants/ComingSoon";
import Container from "../componants/Container";

const Home = () => {
  return (
    <Container>
      <ComingSoon />
    </Container>
  );
};

export default Home;
